import React from 'react';
import { ENDPOINTS } from 'features/command-center/constants';
import strings from 'strings';

import { InterviewsTable } from '../InterviewsTable';

import { COLUMNS, ORDER_BY_OPTIONS, VIRTUAL_PROPS } from './PreparationCalls.constants';

/**
 * @typedef {Object} PreparationCallsProps
 * @property {Filters[]} filters
 */

const COPIES = strings.commandCenter.dominateSheet.preparationCalls;
const TABLE_KEY = 'preparation-calls-list';

/**
 * @param {PreparationCallsProps} props
 */
export const PreparationCalls = ({ filters }) => {
  return (
    <InterviewsTable
      tableKey={TABLE_KEY}
      endpoint={ENDPOINTS.preparationCalls}
      columns={COLUMNS}
      orderByOptions={ORDER_BY_OPTIONS}
      virtualProps={VIRTUAL_PROPS}
      filters={filters}
      title={COPIES.title}
      variant="preparation"
    />
  );
};
